import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "headerDiv mb-2"
}
const _hoisted_2 = { class: "row w-full justify-between flex items-center" }
const _hoisted_3 = { class: "title flex items-center" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  class: "flex justify-end items-center gap-3 flex-shrink-0 mb-2"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_10 = { class: "flex-1 min-h-0 overflow-hidden flex flex-col" }
const _hoisted_11 = { class: "tableCornerRadius bg-white flex-1 min-h-0 overflow-hidden flex flex-col" }
const _hoisted_12 = { class: "table-container flex-1 min-h-0 overflow-y-auto" }
const _hoisted_13 = { class: "buttomStyle table-header-row" }
const _hoisted_14 = { class: "header cursor-pointer w-[10%]" }
const _hoisted_15 = { class: "flex items-center ml-4" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "flex"
}
const _hoisted_19 = {
  key: 1,
  class: "flex"
}
const _hoisted_20 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_27 = ["colspan"]
const _hoisted_28 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 2,
  class: "tbodylast"
}
const _hoisted_31 = { class: "flex items-center ml-4" }
const _hoisted_32 = ["value", "checked"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "table-ellipsis" }
const _hoisted_38 = ["onMousemove"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_41 = { class: "flex flex-col h-full" }
const _hoisted_42 = { class: "flex-1 overflow-auto" }
const _hoisted_43 = { class: "statuscontainer p-2" }
const _hoisted_44 = { class: "formcontainer flex flex-col" }
const _hoisted_45 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_46 = { class: "p-2 w-full" }
const _hoisted_47 = { class: "h-32 mt-2 overflow-y-auto border border-lightgrey p-2 rounded-sm" }
const _hoisted_48 = { class: "text-sm flex flex-wrap" }
const _hoisted_49 = { class: "w-auto h-6 bg-primary mr-3 px-2 rounded-sm flex items-center text-white text-sm" }
const _hoisted_50 = {
  key: 1,
  class: "row flex flex-row w-full"
}
const _hoisted_51 = { class: "p-2 w-full" }
const _hoisted_52 = { class: "h-32 mt-2 overflow-y-auto border border-lightgrey p-2 rounded-sm" }
const _hoisted_53 = { class: "text-sm flex flex-wrap" }
const _hoisted_54 = { class: "w-auto h-6 bg-primary mr-3 px-2 rounded-sm flex items-center text-white text-sm" }
const _hoisted_55 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_56 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_57 = { class: "pl-2 w-11/12" }
const _hoisted_58 = { class: "statuscontainer p-2" }
const _hoisted_59 = { class: "formcontainer flex flex-col" }
const _hoisted_60 = { class: "row flex flex-row w-full" }
const _hoisted_61 = { class: "w-6/12 px-2" }
const _hoisted_62 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_63 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_64 = { class: "w-6/12 px-2" }
const _hoisted_65 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_66 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_67 = { class: "row flex flex-row w-full" }
const _hoisted_68 = { class: "w-6/12 px-2" }
const _hoisted_69 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_70 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_71 = {
  key: 0,
  class: "w-6/12 px-2"
}
const _hoisted_72 = {
  key: 0,
  class: "flex flex-col mt-1"
}
const _hoisted_73 = { key: 1 }
const _hoisted_74 = {
  key: 1,
  class: "w-6/12 px-2"
}
const _hoisted_75 = { class: "row flex flex-row w-full" }
const _hoisted_76 = { class: "w-6/12 px-2" }
const _hoisted_77 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_78 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_79 = { class: "w-6/12 px-2" }
const _hoisted_80 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_81 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_82 = { class: "row flex flex-row w-full" }
const _hoisted_83 = { class: "w-full px-2" }
const _hoisted_84 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_85 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_86 = { class: "row flex flex-row w-full" }
const _hoisted_87 = { class: "w-full px-2" }
const _hoisted_88 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_89 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_90 = { class: "row flex flex-row w-full" }
const _hoisted_91 = { class: "w-full px-2" }
const _hoisted_92 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_93 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_94 = { class: "row flex flex-row w-full" }
const _hoisted_95 = { class: "w-full px-2" }
const _hoisted_96 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_97 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_98 = { class: "row flex flex-row w-full" }
const _hoisted_99 = { class: "w-full px-2" }
const _hoisted_100 = {
  key: 0,
  class: "text-sm mt-2 mb-3"
}
const _hoisted_101 = {
  key: 1,
  class: "text-sm mt-2 mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal mapping-modal' : 'flexcontainer pt-3 pl-5 pr-5 bg-#f9f9fb')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", {
                class: _normalizeClass(_ctx.titleLength > 40? 'heading-ellipsis':'')
              }, _toDisplayString(_ctx.objectiveMainName), 3)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btnprimary", _ctx.defNotEqual ? 'btnprimary' : 'btndisabled pointer-events-none']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mapControlsToBeforeState()))
              }, "Cancel", 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btnprimary", _ctx.defNotEqual ? 'btnprimary' : 'btndisabled pointer-events-none']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mapControls()))
              }, "Save", 2),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: _normalizeClass(["flex", !_ctx.columnObject	 ? 'filterButton' : 'btndisabled pointer-events-none']),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
                }, [
                  (_ctx.columnObject)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                  _cache[15] || (_cache[15] = _createTextVNode(" Filters "))
                ], 2)
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btnprimary", _ctx.defNotEqual ? 'btnprimary' : 'btndisabled pointer-events-none']),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mapControlsToBeforeState()))
          }, "Cancel", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btnprimary", _ctx.defNotEqual ? 'btnprimary' : 'btndisabled pointer-events-none']),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.mapControls()))
          }, "Save", 2),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex", !_ctx.columnObject	 ? 'filterButton' : 'btndisabled pointer-events-none']),
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.columnObject)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : (_openBlock(), _createElementBlock("img", _hoisted_9)),
              _cache[16] || (_cache[16] = _createTextVNode(" Filters "))
            ], 2)
          ])
        ])),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_13, [
                _createElementVNode("th", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkbox cursor-pointer",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectAllControls) = $event)),
                      name: "checkbox",
                      disabled: _ctx.controlsList.length == 0,
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectAllObjectiveControls($event)))
                    }, null, 40, _hoisted_16), [
                      [_vModelCheckbox, _ctx.selectAllControls]
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                  return (_openBlock(), _createElementBlock("th", {
                    scope: "col",
                    key: column,
                    class: _normalizeClass(["bg-white cursor-pointer capitalize", _ctx.getColumnHeadWidth(column)]),
                    onClick: ($event: any) => (_ctx.sort(column))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(column=='priority'?'flex justify-center items-center':'')
                    }, [
                      (column == 'priority')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", null, _toDisplayString(column), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["sort cursor-pointer", _ctx.className == column && !_ctx.columnObject ? _ctx.classSort : 'opacity-50'])
                            }, null, 2)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", null, _toDisplayString(column), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["sort cursor-pointer", _ctx.className == column && !_ctx.columnObject ? _ctx.classSort : 'opacity-50'])
                            }, null, 2)
                          ]))
                    ], 2)
                  ], 10, _hoisted_17))
                }), 128))
              ]),
              (_ctx.showFilters)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                    _cache[17] || (_cache[17] = _createElementVNode("td", null, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (name) => {
                      return (_openBlock(), _createElementBlock("td", {
                        class: _normalizeClass(["bg-white", _ctx.getFilterStyles(name)]),
                        key: name
                      }, [
                        (name == 'priority')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              class: _normalizeClass(["priorityStyles", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                              "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                            }, [
                              _createElementVNode("option", {
                                value: _ctx.filters.name,
                                selected: "",
                                disabled: "",
                                hidden: ""
                              }, "Select", 8, _hoisted_22),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (value, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  class: "optionColors",
                                  key: index,
                                  value: value.value
                                }, _toDisplayString(value.key), 9, _hoisted_23))
                              }), 128))
                            ], 10, _hoisted_21)), [
                              [_vModelSelect, _ctx.filters[name]]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              type: "text",
                              class: "searchForInputBoxStyling",
                              placeholder: "Search",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                            }, null, 8, _hoisted_24)), [
                              [_vModelText, _ctx.filters[name]]
                            ])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.dataLoading == true)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_25, [
                  _createElementVNode("tr", _hoisted_26, [
                    _createElementVNode("td", {
                      class: "relative h-5",
                      colspan: _ctx.columnNames.size
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_dots_loader)
                      ])
                    ], 8, _hoisted_27)
                  ])
                ]))
              : (_ctx.sortedData.length == 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_29, _cache[18] || (_cache[18] = [
                    _createElementVNode("tr", { class: "cursor-pointer rowHeight" }, [
                      _createElementVNode("td", {
                        class: "relative h-10",
                        colspan: 6
                      }, [
                        _createElementVNode("div", { class: "flex justify-center" }, [
                          _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                        ])
                      ])
                    ], -1)
                  ])))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (control, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: control._id,
                        class: "rowHeight hoverEffectForCompleteRow"
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "checkbox",
                              class: "checkbox cursor-pointer",
                              value: control,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedObjects) = $event)),
                              checked: _ctx.checkCheckbox(),
                              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectControls($event)))
                            }, null, 40, _hoisted_32), [
                              [_vModelCheckbox, _ctx.selectedObjects]
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: column,
                            onMouseout: _cache[10] || (_cache[10] = ($event: any) => (_ctx.doFalse())),
                            class: _normalizeClass([column=='priority'?'flex justify-center items-center':'', "cursor-pointer relative"]),
                            onClick: ($event: any) => (_ctx.showEditPopUp(control, index))
                          }, [
                            (column == 'priority' && typeof control[column] === 'number')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28", _ctx.colorPriorityBg(control[column])])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.colorPriorityText(control[column]))
                                  }, [
                                    (control[column])
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.dbPriority.find((l) => {
															return l.value === control[column];
														}).key), 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_35, "-"))
                                  ], 2)
                                ], 2))
                              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", {
                                      onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, control, 'text'))
                                    }, _toDisplayString(control[column]), 41, _hoisted_38)
                                  ]),
                                  (_ctx.pop == true && _ctx.sortedData[_ctx.tipIndex][column] == _ctx.tipText && _ctx.tipColumn == column && _ctx.tipIndex == index)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _createVNode(_component_tool_tip, {
                                          columnName: column,
                                          tipText: _ctx.tipText,
                                          styling: _ctx.styling
                                        }, null, 8, ["columnName", "tipText", "styling"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                          ], 42, _hoisted_33))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
          ]),
          (_ctx.sortedData.length != 0)
            ? (_openBlock(), _createBlock(_component_pagination, {
                key: 0,
                dynamicPagination: _ctx.dynamicPagination,
                onCurrentPageUpdate: _ctx.paginationUpdations,
                sortedData: _ctx.sortedData
              }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.mapPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.mapPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _cache[20] || (_cache[20] = _createElementVNode("h1", { class: "pl-2" }, "Objective Controls", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[11] || (_cache[11] = ($event: any) => {
								_ctx.onCancelbtn('mapPopup');
								this.mapPopup = false;
							})
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          (_ctx.selectedControlsForMap.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _cache[21] || (_cache[21] = _createElementVNode("label", {
                                    for: "Controls",
                                    class: "controllabel"
                                  }, "Selected Controls", -1)),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayMappedControlOptions, (map) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: map,
                                          class: "pb-2"
                                        }, [
                                          _createElementVNode("div", _hoisted_49, _toDisplayString(map.label), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.deSelectControlsForMap.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _cache[22] || (_cache[22] = _createElementVNode("label", {
                                    for: "Controls",
                                    class: "controllabel"
                                  }, "Deselected Controls", -1)),
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mappedDeSelectedControlOptions, (map) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: map,
                                          class: "pb-2"
                                        }, [
                                          _createElementVNode("div", _hoisted_54, _toDisplayString(map.label), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_55, [
                  (_ctx.isLoading && _ctx.deSelectControlsForMap.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btnprimary opacity-100",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveControls()))
                      }, "Update"))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btnprimary opacity-100",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveControls()))
                      }, "Save"))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.popUpControl)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          popUp: _ctx.popUpControl
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("h1", _hoisted_57, _toDisplayString(_ctx.controlObjectiveObj.controlNumber), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[14] || (_cache[14] = ($event: any) => {
								_ctx.onCancelbtn('popUpControl');
								this.popUpControl = false;
							})
              }, _cache[24] || (_cache[24] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                          (!_ctx.controlObjectiveObj.controlNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.controlObjectiveObj.controlNumber), 1))
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                          (!_ctx.controlObjectiveObj.controlTitle)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.controlObjectiveObj.controlTitle), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _cache[27] || (_cache[27] = _createElementVNode("label", { class: "controllabel" }, "Type", -1)),
                          (!_ctx.controlObjectiveObj.controlType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_ctx.controlObjectiveObj.controlType), 1))
                        ]),
                        (_ctx.controlObjectiveObj.controlPriority != undefined && _ctx.controlObjectiveObj.controlPriority != null && _ctx.controlObjectiveObj.controlPriority !='N/A' && _ctx.controlObjectiveObj.controlPriority)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (dataValue, indexNum) => {
                                return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                  (_ctx.controlObjectiveObj.controlPriority == dataValue.value )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                                        (dataValue.key)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorLabelBg(_ctx.controlObjectiveObj.controlPriority)])
                                            }, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.controlObjectiveObj.controlPriority)])
                                              }, _toDisplayString(_ctx.getProirityLabel(_ctx.controlObjectiveObj.controlPriority)), 3)
                                            ], 2))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_73, "N/A"))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_74, _cache[29] || (_cache[29] = [
                              _createElementVNode("label", { class: "controllabel" }, "Priority", -1),
                              _createElementVNode("div", { class: "text-sm mt-2 mb-3" }, _toDisplayString('N/A'), -1)
                            ])))
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _cache[30] || (_cache[30] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                          (!_ctx.controlObjectiveObj.controlFamily)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.controlObjectiveObj.controlFamily), 1))
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                          (!_ctx.controlObjectiveObj.controlClass)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.controlObjectiveObj.controlClass), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", { class: "controllabel" }, "Audit Methodology", -1)),
                          (!_ctx.controlObjectiveObj.controlAuditMethodology)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.controlObjectiveObj.controlAuditMethodology), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", { class: "controllabel" }, "Audit Success Criteria", -1)),
                          (!_ctx.controlObjectiveObj.controlGuidance)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(_ctx.controlObjectiveObj.controlGuidance), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _cache[34] || (_cache[34] = _createElementVNode("label", { class: "controllabel" }, "Maintenance Task", -1)),
                          (!_ctx.controlObjectiveObj.controlMaintenanceTask)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.controlObjectiveObj.controlMaintenanceTask), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                          _cache[35] || (_cache[35] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                          (!_ctx.controlObjectiveObj.controlPolicies)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(_ctx.controlObjectiveObj.controlPolicies), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          _cache[36] || (_cache[36] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                          (!_ctx.controlObjectiveObj.controlGuidance)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString('N/A')))
                            : (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(_ctx.controlObjectiveObj.controlGuidance), 1))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ], 2))
}